import React, {
  createContext,
  useCallback,
  useContext,
  useState,
} from "react";
/* eslint-disable react-refresh/only-export-components */

import {
  getConsent,
  setConsent as setConsentStorage,
  type ConsentStatus,
} from "./analyticsConsent";

interface AnalyticsConsentContextValue {
  consentStatus: ConsentStatus;
  setConsent: (status: "granted" | "denied") => void;
  showBanner: boolean;
}

const AnalyticsConsentContext =
  createContext<AnalyticsConsentContextValue | null>(null);

export function AnalyticsConsentProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [consentStatus, setConsentState] = useState<ConsentStatus>(() =>
    getConsent(),
  );

  const setConsent = useCallback((status: "granted" | "denied") => {
    setConsentStorage(status);
    setConsentState(status);
  }, []);

  const value: AnalyticsConsentContextValue = {
    consentStatus,
    setConsent,
    showBanner: false,
  };

  return (
    <AnalyticsConsentContext.Provider value={value}>
      {children}
    </AnalyticsConsentContext.Provider>
  );
}

export function useAnalyticsConsent(): AnalyticsConsentContextValue {
  const ctx = useContext(AnalyticsConsentContext);
  if (!ctx) {
    throw new Error(
      "useAnalyticsConsent must be used within AnalyticsConsentProvider",
    );
  }
  return ctx;
}
